import {
  IsOptional,
  IsString,
  IsEnum,
  IsDateString,
  IsArray,
  IsObject,
  MaxLength,
  IsUrl,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Theme } from '../enums'

/**
 * DTO pour mettre à jour le profil utilisateur
 */
export class UpdateProfileDto {
  @ApiPropertyOptional({ description: "Nom d'affichage" })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  displayName?: string

  @ApiPropertyOptional({ description: "URL de l'avatar" })
  @IsOptional()
  @IsUrl()
  @MaxLength(1024)
  avatarUrl?: string

  @ApiPropertyOptional({ description: 'Locale (ex: fr, en)', example: 'fr' })
  @IsOptional()
  @IsString()
  @MaxLength(16)
  locale?: string

  @ApiPropertyOptional({
    description: 'Fuseau horaire',
    example: 'Europe/Paris',
  })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  timezone?: string

  @ApiPropertyOptional({ enum: Theme, description: "Thème de l'interface" })
  @IsOptional()
  @IsEnum(Theme)
  theme?: Theme

  @ApiPropertyOptional({
    description: 'Date de naissance',
    type: 'string',
    format: 'date-time',
  })
  @IsOptional()
  @IsDateString()
  birthDate?: string

  @ApiPropertyOptional({ description: 'Genre', maxLength: 32 })
  @IsOptional()
  @IsString()
  @MaxLength(32)
  gender?: string

  @ApiPropertyOptional({
    description: 'Langues parlées',
    type: [String],
    example: ['fr', 'en'],
  })
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  spokenLanguages?: string[]

  @ApiPropertyOptional({
    description: 'Paramètres additionnels (JSON)',
    type: 'object',
    additionalProperties: true,
  })
  @IsOptional()
  @IsObject()
  settings?: Record<string, any>

  @ApiPropertyOptional({
    description: 'Métadonnées additionnelles (JSON)',
    type: 'object',
    additionalProperties: true,
  })
  @IsOptional()
  @IsObject()
  metadata?: Record<string, any>
}
